import { atom } from 'jotai';
import type { DispatchEvents } from '~/utils/events';

type Events = DispatchEvents | Record<string, never>;

export const eventsAtom = atom<Events>({});

export const handleEventsUpdateAtom = atom(null, (_, set, update: Events) => {
  set(eventsAtom, (prev) => ({ ...prev, ...update }));
});
